import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        name: 'helloVueX',
        isLogin: false,
    },
    mutations: {
        setLoginState(state, data) {
            state.isLogin = data;
        },
    }

})

export default store


// WEBPACK FOOTER //
// ./src/components/common/store/index.js